import type { infer as zInfer } from "zod/v4";
import * as z from "zod/v4";

export const getBigcommerceIntegration = {
  name: "getBigcommerceIntegration" as const,
  input: z.object({}),
  output: z.union([
    z.object({
      exchangeOrderStatus: z.number(),
      enabled: z.boolean().nullish(),
    }),
    z.undefined(),
  ]),
};

export type BigcommerceIntegration = zInfer<
  typeof getBigcommerceIntegration.output
>;
